import React from "react";
import { NavLink } from "react-router-dom";
import { GrEdit } from "react-icons/gr";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { FaCloudUploadAlt } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import { GrRefresh } from "react-icons/gr";
import { BsCheckCircleFill } from "react-icons/bs";
import { BsFillXCircleFill } from "react-icons/bs";

import { Container, Stack, Button, Form, Table } from "react-bootstrap";
import getAllPlantillas from "../functions/getAllPlantillas";
import eliminarUsuario from "../functions/eliminarUsuario";
import filtrarPlantillas from "../functions/filtrarPlantillas";

//modales
import ModalAñadir from "../components/ModalAñadir";
import ModalEditar from "../components/ModalEditar";
import ModalUpload from "../components/ModalUpload";

function Dplantillas({ usuario }) {
  //console.log(usuario);
  const [productos, setProductos] = React.useState([]);
  const [isModalAñadir, setIsModalAñadir] = React.useState(false);
  const [isModalEditar, setIsModalEditar] = React.useState(false);
  const [isModalUpload, setIsModalUpload] = React.useState(false);
  const [productoEditar, setProductoEditar] = React.useState(null);
  const ruc = usuario.ruc;
  const baseDatos = "plantillaDocumentos";

  const param1 = 'valor1';
  const param2 = 'valor2';

  async function busquedaFormHandler(e) {
    e.preventDefault();
    const busqueda = e.target.busqueda.value;
    const nvosDocus = await filtrarPlantillas(busqueda, baseDatos, ruc);
    setProductos(nvosDocus);
  }

  function actualizarEstadoProductos(db, ruc) {
    getAllPlantillas(db, ruc).then((productos) => {
      setProductos(productos);
    });
  }

  function añadirProductoHome() {
    setIsModalAñadir(true);
  }

  React.useEffect(() => {
    actualizarEstadoProductos(baseDatos, ruc); // TODO: cambiar por el ruc del usuario
    //contadorDplantillas(baseDatos, ruc);
  }, []);

  return (
    <Container className="my-5">
      <h2>Plantilla de documentos</h2>
      <div>
        <ModalAñadir
          isModalAñadir={isModalAñadir}
          setIsModalAñadir={setIsModalAñadir}
          actualizarEstadoProductos={actualizarEstadoProductos}
          usuario={usuario}
        />
        {productoEditar && (
          <ModalEditar
            isModalEditar={isModalEditar}
            setIsModalEditar={setIsModalEditar}
            actualizarEstadoProductos={actualizarEstadoProductos}
            productoEditar={productoEditar}
            setProductoEditar={setProductoEditar}
            usuario={usuario}
          />
        )}
        {productoEditar && (
          <ModalUpload
            isModalUpload={isModalUpload}
            setIsModalUpload={setIsModalUpload}
            actualizarEstadoProductos={actualizarEstadoProductos}
            productoEditar={productoEditar}
            setProductoEditar={setProductoEditar}
            usuario={usuario}
          />
        )}


        <Form onSubmit={busquedaFormHandler}>
          <Stack direction="horizontal">
            <Form.Group controlId="busqueda" className="w-75 m-3">
              <Form.Control type="text" placeholder="Buscar" />
            </Form.Group>
            <Button
              variant="light"
              type="submit">
              <FaSearch size="20px" color="blue" />
            </Button>
            <Button
              variant="light"
              onClick={() => {
                const input = document.getElementById("busqueda");
                input.value = "";
                actualizarEstadoProductos(baseDatos, ruc)
              }}
            >
              <GrRefresh size="20px" color="blue" />
            </Button>
          </Stack>
        </Form>

        <hr />
        <div style={{ maxHeight: "500px", overflowY: "auto" }}>
          <Table>
            <thead>
              <tr>
                <th scope="col">N°</th>
                <th scope="col">E</th>
                <th scope="col">Código</th>
                <th scope="col">Título</th>
                <th scope="col">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {productos &&
                productos.map((producto, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    {producto.activo ? (
                      <td>
                        <BsCheckCircleFill size="15px" color="green" />
                      </td>
                    ) : (
                      <td>
                        <BsFillXCircleFill size="15px" color="red" />
                      </td>
                    )}
                    <td>{producto.codigo}</td>
                    <td>{producto.nombre}</td>
                    <td>
                      <Button
                        variant="light"
                        onClick={() => {
                          setProductoEditar({ ...producto });
                          setIsModalEditar(true);
                        }}
                      >
                        <GrEdit size="20px" color="black" />
                      </Button >{" "}
                      <Button
                        variant="light"
                        onClick={() => {
                          eliminarUsuario(producto, usuario.email, baseDatos).then(
                            (confirmacion) => {
                              actualizarEstadoProductos(baseDatos, ruc); // TODO: cambiar por el ruc del usuario
                            }
                          );
                        }}
                      >
                        <RiDeleteBin6Fill size="21px" color="red" />
                      </Button>{" "}
                      <NavLink to={{ pathname: '/gdocumentos', search: `?id=${producto.id}` }}>
                        <FaCloudUploadAlt size="22px" color="blue" placeholder="Subir Documento" />
                      </NavLink>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
        <Button onClick={añadirProductoHome}> Añadir Plantilla</Button>
      </div>
    </Container>
  );
}

export default Dplantillas;
